import React from 'react';

var ListView = function ListView(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm0 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm7-11a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2h-7zm0 6a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2h-7zm0 6a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2h-7z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

ListView.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ListView as icon };
export default iconHandler(ListView);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ListView.js
// module id = 608
// module chunks = 0